import { FormControl, Text } from "native-base";
import React, { JSXElementConstructor, ReactElement } from "react";
import { Control, Controller, FieldError, FieldValues, Path, PathValue } from "react-hook-form";

type FormFieldProps<FieldType extends FieldValues> = {
  name: Path<FieldType>;
  label: string;
  hint?: string;
  required?: boolean;
  control: Control<FieldType, any>;
  error?: FieldError | string;
  render: (
    value: PathValue<FieldType, Path<FieldType>>,
    onChange: (...event: any[]) => void
  ) => ReactElement<any, string | JSXElementConstructor<any>>;
};

const FormField = <FieldType extends FieldValues>({
  render,
  control,
  name,
  error,
  label,
  hint,
  required = false,
}: FormFieldProps<FieldType>) => {
  return (
    <FormControl isRequired={required} isInvalid={!!error}>
      <FormControl.Label>
        <Text isTruncated>{label}</Text>
      </FormControl.Label>
      <Controller
        control={control}
        render={({ field: { value, onChange } }) => render(value, onChange)}
        name={name}
        defaultValue={"" as PathValue<FieldType, Path<FieldType>>}
      />
      <FormControl.HelperText>{hint}</FormControl.HelperText>
      <FormControl.ErrorMessage>
        {typeof error === "string" ? error : error?.message}
      </FormControl.ErrorMessage>
    </FormControl>
  );
};

export default FormField;
